import { getPrice } from '../../../../../lib';

interface IProps {
  readonly money: string | number | undefined;
  readonly className?: string;
  readonly isNegative?: boolean;
}

export const GetformatMoney = (props: IProps) => {
  const formatMoney = (money: string | null) => {
    if (money) {
      const [integerPart, decimalPart] = money.split('.');
      // eslint-disable-next-line radix
      const formattedIntegerPart = parseInt(integerPart).toLocaleString();
      const decimal = decimalPart;
      // 判断是否为负数
      const isNegative =
        props.isNegative !== undefined
          ? props.isNegative
          : // eslint-disable-next-line radix
            parseInt(integerPart) < 0;
      return (
        <span
          className={`normal-details-money ${
            isNegative ? 'minus-balance-money' : ''
          } ${props.className}`}
        >
          <span className="icon">¥</span>
          <span>{formattedIntegerPart}</span>
          <span>.</span>
          <span className="dot-number">{decimal}</span>
        </span>
      );
    }
    return null;
  };

  return <>{formatMoney(getPrice(props.money).amount)}</>;
};
